import { useScrollReveal } from "@/hooks/useScrollReveal";
import { eyebrowServices } from "@/mocks/services";

export default function EyebrowServices() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section
      id="servicos-sobrancelhas"
      className="py-20 md:py-32 bg-background-50"
    >
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="max-w-2xl mb-16">
          <p className="flex items-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-600 mb-6">
            <span className="w-10 h-[1px] bg-primary-500/60" />
            Olhar Impecável
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-5 leading-tight">
            Design de Sobrancelhas
          </h2>
          <p className="text-foreground-500 text-sm md:text-base font-light leading-relaxed">
            Técnicas precisas que valorizam o seu olhar e harmonizam suas
            feições — incluindo design, henna, tintura e brow lamination
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {eyebrowServices.map((service, i) => (
            <article
              key={service.id}
              className="group flex flex-col bg-background-100 border border-background-200 hover:border-primary-300 rounded-2xl p-6 md:p-7 transition-colors duration-500"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full border border-primary-500/30 text-primary-600 mb-5 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-950 group-hover:border-primary-500">
                <i className={`${service.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>

              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3 leading-snug">
                {service.title}
              </h3>

              <p className="text-xs md:text-sm text-foreground-600 font-light leading-relaxed mb-6 flex-1">
                {service.description}
              </p>

              <a
                href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-primary-700 hover:text-primary-500 text-[12px] font-label uppercase tracking-[0.14em] font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Agendar
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}